import { X } from 'lucide-react';
import { AVATAR_URL } from './constants';

export const ChatHeader = ({ onClose }) => (
  <div className="flex items-center justify-between p-4 border-b border-[#27272A] bg-[#050505] flex-shrink-0 safe-area-top">
    <div className="flex items-center gap-3">
      <div className="w-10 h-10 rounded-full overflow-hidden border border-[#007AFF]">
        <img src={AVATAR_URL} alt="Terry's Assistant" className="w-full h-full object-cover" />
      </div>
      <div>
        <p className="font-bold text-white">Terry's Assistant</p>
        <p className="text-xs text-[#52525B]">Typically replies instantly</p>
      </div>
    </div>
    <button
      onClick={onClose}
      className="p-2 text-[#52525B] hover:text-white transition-colors"
      aria-label="Close chat"
      data-testid="chatbot-close"
    >
      <X className="w-5 h-5" />
    </button>
  </div>
);
